<template>
	<div class="page news">
		<TopSubMenu :menu = "$store.state.gnb.menuList[2].subMenu"></TopSubMenu>

		<!-- news -->
		<section class="secWrap newsWrap">
			<div class="topBgWrap" :style="topBgStyle"></div>
			<div class="pageContentWrap">
				<div class="pageTitleWrap">
					<p class="subTxt">{{this.news.top.subTxt.txt}}</p>
					<h2 class="titleTxt">{{this.news.top.title.txt}}</h2>
				</div>
				<div class="pageHeaderBoxWrap" :style="pageHeaderStyle">
					<h3 class="pageHeaderTitle bold" :class="[news.pageHeader.title.pos]" v-html="this.news.pageHeader.title.txt"></h3>
					<p class="pageHeaderTxt" v-html="this.news.pageHeader.subTxt.txt"></p>
				</div>
				<div class="seachingWrap">
					<ul class="searchOption">
						<li class="on">최신순</li>
						<!-- <li>중요순</li> -->
					</ul>
				</div>
				<div class="newsList">
					<div class="newsItem" v-for="(item, index) in news.list" :id="item.id" :key="'newsItem' + index"  @click="goBoardItemView(index)">
						<div class="thumbWrap">
							<div class="imgWrap">
								<img :src="$store.getters.getUrlPrefix+item.mainImg" alt="">
							</div>
						</div>
						<div class="itemContentWrap">
							<h4 class="titleTxt">{{item.title}}</h4>
							<div class="subTxt">
								<div v-if="item.content.html">
									<div v-for="(pageContentRowItem, rowIndex) in item.content" :key="'rowIndex'+rowIndex">
										<div v-html="pageContentRowItem.html"></div>
									</div>
								</div>
								<div else>
									<div v-html="item.shortCont"></div>
								</div>
							</div>
							<p class="date">{{item.registDt}}</p>
						</div>
						<BtnLink class="btnLink" size="is-small"></BtnLink>
					</div>
				</div>
			</div>
		</section>
		<button class="btnMore" v-if="btnMore" @click="moreListDisplay">더보기<b-icon icon="plus" size="is-small" type="is-white"></b-icon></button>
		<Footer/>
	</div>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
import BtnLink from '../components/ButtonLinkPage'
import TopSubMenu from '../components/TopSubMenu'
import Footer from '../components/Footer'

export default {
	name: 'News',
	components: {
		BtnLink,
		TopSubMenu,
		Footer
	},
	watch: {
		news: {
			deep: true,
			immediate: true,
			handler () {
				console.log('The list of data has changed!')
			}
		}
	},
	data () {
		return {
			pageNum: 1,
			btnMore: true,
			news: {
				background: {
					color: '#fff',
					image: require('@/assets/images/bg-news-top@2x.jpg'),
					size: 'cover',
					width: '100%'
					// height: '284px'
				},
				top: {
					title: {
						txt: '두손소프트 뉴스',
						fontWeight: 'bold'
					},
					subTxt: {
						txt: '새로운 소식을 알려드립니다.',
						fontWeight: 'normal'
					}
				},
				pageHeader: {
					title: {
						txt: 'Twosonsoft\'s <span class="bold">News</span>',
						pos: 'bottom right'
					},
					subTxt: {
						txt: '최근에 두손에는 어떤 일이 있었을까요?<br>새로운 소식들 구경해 보세요.'
					},
					background: {
						color: '#00589B',
						image: ''
					}
				},
				list: [
					/* {
						cate: 'news',
						boardNo: '16',
						mainImg: require('@/assets/images/temp-news-item-1@2x.png'),
						title: '푸르덴셜생명 모바일 명의 변경(다건) 시스템 구축',
						shortCont: '푸르덴셜생명의 구 시스템에 최초로 다건 시스템을 개발하여<br>명의변경 시스템에 반영, 개편하고 있습니다.',
						content: '푸르덴셜생명의 구 시스템에 최초로 다건 시스템을 개발하여<br>명의변경 시스템에 반영, 개편하고 있습니다.',
						registDt: '2020.04.02',
						link: ''
					},
					{
						cate: 'news',
						boardNo: '17',
						mainImg: require('@/assets/images/temp-news-item-2@2x.png'),
						title: '사옥 이전',
						shortCont: '두손소프트는 새로운 도약과 업무환경 개선을 위해<br>사옥을 이전하였습니다.<br>이제 새로운 보금자리에서 더 좋은 서비스 제공을 위해 더 노력하겠습니다.<br>감사합니다.',
						content: '두손소프트는 새로운 도약과 업무환경 개선을 위해<br>사옥을 이전하였습니다.<br>이제 새로운 보금자리에서 더 좋은 서비스 제공을 위해 더 노력하겠습니다.<br>감사합니다.',
						registDt: '2018.01',
						link: ''
					},
					*/
				]
			}
		}
	},
	computed: {
		topBgStyle: function () {
			return {
				backgroundColor: this.news.background.color,
				backgroundImage: 'url(' + this.news.background.image + ')',
				height: this.news.background.height,
				width: this.news.background.width,
				backgroundSize: this.news.background.size ? this.news.background.size : 'cover',
				backgroundPosition: this.news.background.position ? this.news.background.position : 'center center'
			}
		},
		pageHeaderStyle: function () {
			return {
				backgroundColor: this.news.pageHeader.background.color,
				backgroundImage: 'url(' + this.news.pageHeader.background.image + ')',
				height: this.news.pageHeader.background.height,
				width: this.news.pageHeader.background.width,
				backgroundSize: this.news.pageHeader.background.size ? this.news.pageHeader.background.size : 'cover',
				backgroundPosition: this.news.pageHeader.background.position ? this.news.pageHeader.background.position : 'center center'
			}
		}
	},
	mounted () {
		// data load
		this.$axios.post(this.$store.state.dataUrl + '/twosonBoardList?cate=news&page' + this.pageNum)
			.then(response => {
				console.log('newsList : ', response.data)
				this.news.list = response.data
			})
			.catch(error => {
				console.log('* error : ' + error.response)
			})
	},
	created () {
		AOS.init({
			duration: 600,
			easing: 'ease-in-sine',
			delay: 100
		})
	},
	destroyed () {},
	methods: {
		goBoardItemView (idx) {
			console.log('> goBoardItemView :' + idx)
			console.log('send data: ', this.news.list[idx])
			this.$router.push({ path: 'boardview', query: { board: 'news', num: idx, boardNo: this.news.list[idx].boardNo } })
		},
		moreListDisplay () {
			console.log('> moreListDisplay')
			this.pageNum++
			var link = this.$store.state.dataUrl + '/twosonBoardList?cate=news&page=' + this.pageNum
			this.$axios.post(link)
				.then(response => {
					if (response.data.length > 0) {
						if (response.data.length < 10) {
							this.btnMore = false
						}
						this.news.list = this.news.list.concat(response.data)
					} else {
						this.btnMore = false
					}
				})
				.catch(error => {
					console.log('* error : ' + error.response)
				})
		}
	}
}
</script>

<style lang="scss">
.page {
	.secWrap {
		.pageContentWrap {
			.pageHeaderBoxWrap {
				$pd: 40px;
				.top,
				.right,
				.bottom,
				.left {
					position: absolute;
				}
				.pageHeaderTitle {
					&.top {top: $pd;}
					&.right {right: $pd;}
					&.bottom {bottom: $pd;}
					&.left {left: $pd;}
				}
			}
		}
	}
}
</style>

<style lang="scss" scoped>
@import '@/css/variables.scss';
.page {
	position: relative;
	padding-top: 88px;
	height: auto;
	width: 100%;
	background-color: $c-white;
	.secWrap {
		position: relative;
		width: 100%;
		margin: 0 auto;
		padding: 0;
		.topBgWrap {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 284px;
			z-index: 0;
		}
		.pageContentWrap {
			position: relative;
			margin: 0 auto;
			.pageTitleWrap{
				padding: 74px 0;
				.titleTxt {
					color: $c-white; font-size: $title-medium; font-weight: bold;
				}
				.subTxt {
					color: $c-gray-light; font-size: $text-normal;
				}
			}
			.pageHeaderBoxWrap {
				$pd: 40px;
				$h: 176px;
				$maxR: 70%;
				$maxL: 100% - $maxR;
				position: relative;
				padding: $pd;
				border-radius: 8px;
				height: $h;
				box-shadow: 0x 3px 6px rgba(0,0,0,0.16);
				margin-bottom: 24px;
				.pageHeaderTitle {
					color: $c-white;
					font-size: $title-small;
					max-width: $maxL;
				}
				.pageHeaderTxt {
					color: $c-white;
					font-size: $text-small;
					max-width: $maxR;
					// line-height: 1.5em;
				}
			}
			.seachingWrap{
				margin-bottom: 28px;
				.searchOption{
					position: relative;
					text-align: right;
					li {
						display: inline-block;
						margin-left: 24px;
						color: $c-gray-light2;
						&.on {
							color: $c-blue-dark;
							font-weight: bold;
						}
					}
				}
			}
			.newsList {
				padding-bottom: 80px;
				.newsItem {
					$pd: 20px;
					position: relative;
					display: flex;
					width: 100%;
					border: 1px solid #C4C4C4;
					padding: $pd;
					background-color: $c-white;
					margin-bottom: 20px;
					&:last-child {
						margin-bottom: 0;
					}
					.thumbWrap {
						width: 400px;
						height: 296px;
						imgWrap{
							img {
								width: 100%;
							}
						}
					}
					.itemContentWrap {
						position: relative;
						margin-left: 30px;
						width: calc(100% - 440px);
						cursor: pointer;
						.titleTxt {
							color: $c-gray-black; font-weight: bold; font-size: $title-xsmall;
							margin-bottom: 20px;
						}
						.subTxt {color: $c-gray-dark; word-break: break-all;}
						.date {
							position: absolute;
							left: 0;
							bottom: 0;
							color: $c-gray-light2; font-size: $text-tiny;
						}
					}
					.btnLink {
						position: absolute;
						bottom: $pd;
						right: $pd;
					}
				}
			}
		}
	}
	.btnMore {
		display: block;
		width: 100%;
		height: 90px;
		text-align: center;
		font-size: $text-medium; color: $c-white;
		background-color: $c-gray-m;
		cursor: pointer;
		.icon {margin-left: 8px;}
	}

	.imgWrap img {
		width: auto;
		height: inherit;
		max-height: max-content;
	}
}
/*
	##Device = Laptops, Desktops
	##Screen = B/w 1025px to 1280px
*/
@media (min-width: 1025px) and (max-width: 1280px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (portrait)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	.page {
		.secWrap {
			.pageContentWrap {
				.pageTitleWrap {
					padding: 74px 30px;
				}
				.pageHeaderBoxWrap {
					padding: 30px;
					.pageHeaderTitle {
						max-width: 100%;
						&.bottom {
							bottom: 30px;
						}
						&.right {
							right: 30px;
						}
					}
				}
			}
		}
	}
}

/*
	##Device = Tablets, Ipads (landscape)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  //CSS
}

/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/
@media (min-width: 481px) and (max-width: 767px) {
	.page {
		.secWrap {
			.topBgWrap {
				height: 236px;
			}
			.pageContentWrap {
				.pageTitleWrap {
					padding: 54px 20px 54px;
					.subTxt {
						font-size: $text-small;
					}
					.titleTxt {
						font-size: $title-small;
					}
				}
				.pageHeaderBoxWrap {
					width: calc(100% - 40px);
					margin: 0 20px 24px;
					padding: 26px 20px;
					.pageHeaderTxt {
						max-width: 100%;
					}
					.pageHeaderTitle {
						max-width: 100%;
						font-size: $title-xxsmall;
						&.bottom {
							bottom: 26px;
						}
						&.right {
							right: 20px;
						}
					}
				}
				.seachingWrap {
					padding: 0 20px;
					margin-bottom: 21px;
				}
				.newsList {
					padding: 0 20px 40px;
					.newsItem {
						padding: 0;
						flex-wrap: wrap;
						.thumbWrap {
							width: 100%;
							height: auto;
							margin-bottom: 20px;
							.imgWrap {
								img {
									position: static;
									display: block;
									width: 100%;
									height: auto;
									max-height: 100%;
									transform: none;
								}
							}
						}
						.itemContentWrap {
							width: 100%;
							margin-left: 0;
							padding: 0 15px 55px;
							.titleTxt {
								margin-bottom: 10px;
								font-size: $title-xxsmall;
							}
							.date {
								left: 15px;
								bottom: 15px;
							}
						}
						.btnLink {
							right: 7px;
							bottom: 7px;
							&.btnLinkWrap {
								width: 40px;
								height: 40px;
							}
						}
					}
				}
			}
		}
	}
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	.page {
		.secWrap {
			.topBgWrap {
				height: 236px;
			}
			.pageContentWrap {
				.pageTitleWrap {
					padding: 54px 20px 54px;
					.subTxt {
						font-size: $text-tiny;
					}
					.titleTxt {
						font-size: $title-small;
					}
				}
				.pageHeaderBoxWrap {
					width: calc(100% - 24px);
					margin: 0 12px 24px;
					height: 150px;
					padding: 26px 20px;
					.pageHeaderTxt {
						max-width: 100%;
					}
					.pageHeaderTxt {
						font-size: $text-tiny;
					}
					.pageHeaderTitle {
						max-width: 100%;
						font-size: $title-xxsmall;
						&.bottom {
							bottom: 26px;
						}
						&.right {
							right: 20px;
						}
					}
				}
				.seachingWrap {
					padding: 0 12px;
					margin-bottom: 21px;
				}
				.newsList {
					padding: 0 12px 40px;
					.newsItem {
							padding: 0;
							flex-wrap: wrap;
							.thumbWrap {
								width: 100%;
								height: auto;
								margin-bottom: 20px;
								.imgWrap {
									img {
										position: static;
										display: block;
										width: 100%;
										height: auto;
										max-height: 100%;
										transform: none;
									}
								}
							}
							.itemContentWrap {
								width: 100%;
								margin-left: 0;
								padding: 0 15px 55px;
								.titleTxt {
									margin-bottom: 10px;
									font-size: $title-xxsmall;
								}
								.date {
									left: 15px;
									bottom: 15px;
								}
							}
							.btnLink {
								right: 7px;
								bottom: 7px;
								&.btnLinkWrap {
									width: 40px;
									height: 40px;
								}
							}
					}
				}
			}
		}
	}
}
</style>
